import { render, staticRenderFns } from "./DeliveryMenuShopMapView.vue?vue&type=template&id=bab9453e&scoped=true"
import script from "./DeliveryMenuShopMapView.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuShopMapView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuShopMapView.vue?vue&type=style&index=0&id=bab9453e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab9453e",
  null
  
)

export default component.exports